import { BankAccountInformation } from './BankAccountInformation'
import { withBankAccountInformation } from './withBankAccountInformation'

const ConnectedBankAccountInformation = withBankAccountInformation(
  BankAccountInformation
)
export { ConnectedBankAccountInformation as BankAccountInformation }
